import React from 'react';
import { Button } from '@mui/material';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

const DeleteButton = ({ onClick, label = "Delete", sx = {}, ...props }) => {
  return (
    <Button
      size="small"
      variant="contained"
      startIcon={<DeleteForeverOutlinedIcon />}
      sx={{
        backgroundColor: 'lightcoral',
        color: 'white',
        textTransform: 'none',
        ...sx, // <- allow margin and other custom styles
      }}
      onClick={onClick}
      {...props}
    >
      {label}
    </Button>
  );
};

export default DeleteButton;
